import React from 'react'
import Header from 'components/Header'
import BottomNavigation from 'components/BottomNavigation'
import Loading from 'components/Loading'
import SnackBar from 'components/SnackBar'
import axios from 'axios'
import utils from '../Utils'
import Matrix from 'scripts/Matrix'
import { Link } from 'react-router-dom'
import 'style/CallList.css'

const loadingStyle = {
    margin: '20px auto',
    background: 'rgba(255, 255, 255, 0)',
    display: 'block',
    width: 25,
    height: 25
}

class CallList extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            loading: false,
            loadingMore: false,
            calls: [],
            page: 0,
            pages: 0,
        }
    }

    componentDidMount() {
        this.getVoiceConsultList()
    }

    getVoiceConsultList = async (page = 0, loadMore = false) => {
        if (loadMore)
            this.setState({ loadingMore: true })
        else
            this.setState({ loading: true })

        const res = await axios.get(utils.urls.voiceConsultList + `?page=${page}`, {
            headers: {
                'x-access-token': Matrix.getToken()
            }
        }
        )
            .catch((e) => {
                console.log(e.response)
                let message = (e.response && e.response.data && e.response.data.message) || 'خطایی رخ داده است'
                this.SnackBar.openSnackbar(message)
            });

        if (loadMore)
            this.setState({ loadingMore: false })
        else
            this.setState({ loading: false })

        if (!res) return
        if (!res.data.success) return this.SnackBar.openSnackbar('خطایی پیش آمده است')

        this.setState({
            calls: [...this.state.calls, ...res.data.consultRequests],
            pages: Math.ceil(res.data.count / 10) - 1
        })
    }

    getMore = async () => {
        await this.setState({ page: this.state.page + 1 })
        this.getVoiceConsultList(this.state.page, true)
    }

    render() {
        return (
            <>
                <SnackBar ref={el => this.SnackBar = el} />
                <Header title="طبینجا" showBackButton={false} desc='لیست تماس ها' showBackButton />
                <div className="page-root">
                    {this.state.loading ?
                        <Loading /> :
                        <div>
                            {this.state.calls.map(call =>
                                <div className="voice-call" key={call.id}>
                                    <div className="voice__avatar">
                                        {call.doctor.url ?
                                            <img src={utils.urls.image + call.doctor.url} /> :
                                            <img src="/images/person.svg" />
                                        }
                                    </div>
                                    <div className="voice__detail">
                                        <div className="name-date">
                                            <div className="name">{'دکتر ' + call.doctor.fname + ' ' + call.doctor.lname}</div>
                                            <div className="date">{utils.getJalaiData(call.createdAt)}</div>
                                        </div>
                                        <div className="content">{call.question}</div>
                                        <div className="action">
                                            {call.roomId && <Link className="btn-action room-link" to={`/chat/${call.roomId}`}>رفتن به گفتگو</Link>}
                                        </div>
                                    </div>
                                </div>
                            )}
                            {this.state.loadingMore ?
                                <Loading style={loadingStyle} /> :
                                (this.state.pages > this.state.page) &&
                                <div className="more-button-container">
                                    <button onClick={this.getMore}>نمایش بیشتر</button>
                                </div>
                            }

                        </div>
                    }

                </div>
                <BottomNavigation selected={null} />
            </>
        )
    }
}

export default CallList